import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgSelectComponent } from './pg-select.component';
import { PgOptionDirective } from './pg-option.directive';
import { PortalModule } from '@angular/cdk/portal';
@NgModule({
  imports: [CommonModule, PortalModule],
  declarations: [PgSelectComponent, PgOptionDirective],
  exports: [PgSelectComponent, PgOptionDirective],
})
export class PgSelectModule {}
